import React from 'react'
import cn from "./../../lib/bem";

import './buttonIcon_component.scss';

const ButtonIconComponent = (props) => {

    const classes = cn("buttonIconComponent");
    
    return (
        <div className={classes()}>
            <button type="button" aria-label={props.label} className={classes(props.tipo)} disabled={props.disabled} onClick={props.action}>
                <img src={props.img} alt={props.img}/>
                {props.nombre}
            </button>
        </div>
    )

}

export default ButtonIconComponent
